:host {
  position: relative;
  display: block;
  background-repeat: no-repeat;
  background-size: cover;
  aspect-ratio: auto;
  flex-shrink: 0;
  container-type: inline-size;
}
